<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="title">HELEN RAPPAPORT</p>
<p class="title1">CAUGHT IN THE REVOLUTION</p>
<p class="title2">Petrograd, Russia, 1917—<br/>A World on the Edge</p>
<p class="logo">St. Martin’s Press<br/>New York<br/><img alt="" src="OEBPS/images/logo_st_martin_press.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?7a342a54